import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./VideoPlayer.module.scss";
import PathContext from "../../context/path";
import StatesContext from "../../context/states";
const VideoPlayer = (props) => {
  const path = useContext(PathContext);
  const states = useContext(StatesContext);
  const { articleOpened, endpoint } = states;
  const [isPlaying, setPlaying] = useState(false);
  const refVideo = useRef(null);
  const refOverlay = useRef(null);
  const { src } = props; 
  useEffect(()=>{
    const overlay = refOverlay.current;
    const video = refVideo.current;
    if(isPlaying){
      // overlay.style.opacity = '0';
      // overlay.style.pointerEvents = 'none';
      video.play();
    }else{
      
      // overlay.style.opacity = '';
      // overlay.style.pointerEvents = '';
      video.pause();
    }
  }, [isPlaying]);
  
  useEffect(()=>{
    if(!articleOpened){
      setPlaying(false);
    }
  },[articleOpened]);
  return (
    <>
      <div className={styles.wrap}>
        {/* <div className={styles.overlay} ref={refOverlay}>
          <svg width="85" height="99" viewBox="0 0 85 99" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={()=>{setPlaying(true)}}>
            <path d="M85 49.5L0.249995 98.4304L0.25 0.569561L85 49.5Z" fill="white" fillOpacity="0.7" />
          </svg>

        </div> */}
        <video src={`${src}`} playsInline  ref={refVideo} controls></video>
      </div>
    </>
  );

}

export default VideoPlayer;
